<template>
    <div>
      <table key="packages" id="package-datatable" class="stripe hover">
        <thead>
          <tr>
            <th>id</th>
            <th>รหัส</th>
            <th>ชื่อ</th>
            <th>status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody></tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </template>
  
  <script>
  import BreezeSecondaryButton from "@/Components/SecondaryButton";
  import BreezeDialogModal from "@/Components/DialogModal";
  import BreezeInput from "@/Components/Input";
  
  export default {
    props: [],
    components: {
      BreezeSecondaryButton,
      BreezeDialogModal,
      BreezeInput,
    },
    data() {
      return {
          tokenModal: false,
          newToken: "",
          isChecking: false,
      };
    },
    mounted() {
      let parent = this;
      $("#package-datatable").DataTable({
        dom: "tpr",
        pageLength: 50,
        processing: true,
        serverSide: true,
        order: [[0, "asc"]],
        ajax: "/staff/packages/datatable",
        columns: [
          { data: "id", name: "id", 
            orderable: false,
            searchable: false,},
          { data: "code", name: "code" },
          { data: "name", name: "name" },
          { data: "status", name: "status",
            orderable: false,
            searchable: false,},
          {
            data: "id",
            name: "id",
            orderable: false,
            searchable: false,
            render: function (data, type, row) {
              let btn = `
                  <button type="button" class="bg-blue-500 mr-2 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded documentBtn" data-id="${data}"><i class="fa fa-edit"></i> แสดง</button>
                  <button type="button" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded activeBtn" data-id="${data}"><i class="fa fa-cross"></i> active/inactive</button>`;
              return btn;
            },
          },
        ],
        initComplete: function () {
          //setup datatable when all data ready
          this.api()
            .columns([1])
            .every(function (i) {
              let column = this;
              let input = null;
  
              input = $(document.createElement("input"));
  
              input
                .addClass(
                  "border border-gray-300 p-2 my-2 rounded-md focus:outline-none focus:ring-2 ring-blue-200 w-full"
                )
                .appendTo($(column.footer()).empty())
                .on("change", function () {
                  column.search($(this).val(), false, false, true).draw();
                });
            });
          this.find("tfoot tr").appendTo(this.find("thead"));
        },
        drawCallback: function (settings) {
          $(".documentBtn").click(function () {
            let editRoute = route("staff.packages.edit", {
              package: $(this).data("id"),
            });
            parent.$inertia.get(editRoute);
          });
          
          $(".activeBtn").click(function () {
            let deleteRoute = route("staff.packages.inactive", {
              package: $(this).data("id"),
            });
            parent.$inertia.put(deleteRoute);
          });
        },
      });
    },
    methods:{
      
      
    }
  };
  </script>
  